import { createAsyncThunk } from '@reduxjs/toolkit';

import { api } from 'api';
import { NotificationReader } from 'types';
import { calculateOffset } from 'utils/helpers';
import {
  NotificationRequest,
  NotificationResponse,
} from 'api/notifications/types';

import { MarkAsReadPayload } from './types';
import { markAsRead, markAllAsRead } from './index';

export const fetchNotifications = createAsyncThunk<
  NotificationResponse,
  NotificationRequest | void
>('notifications/fetchNotifications', async (params) => {
  try {
    const { page = 1, limit = 20, ...otherParams } = params || {};
    const offset = calculateOffset(page, limit);
    const searchParams = {
      limit,
      offset,
      ...otherParams,
    };

    const { data } = await api.notifications.getNotifications(searchParams);

    return data;
  } catch (error) {
    console.error('[notification: fetch notifications]', error);
    return Promise.reject(error);
  }
});

export const markAsReadNotification = createAsyncThunk<
  NotificationReader,
  MarkAsReadPayload
>('notifications/markAsRead', async ({ id, readStatus }, { dispatch }) => {
  try {
    const { data } = await api.notifications.markAsRead(id);
    dispatch(markAsRead({ id, readStatus }));

    return data;
  } catch (error) {
    console.error('[notification: mark as read]', error);
    dispatch(markAsRead({ id, readStatus: !readStatus }));
    return Promise.reject(error);
  }
});

export const markAllAsReadNotifications = createAsyncThunk<void, void>(
  'notifications/markAllAsRead',
  async (_, { dispatch }) => {
    try {
      await api.notifications.markAllAsRead();
      dispatch(markAllAsRead());
    } catch (error) {
      console.error('[notification: mark all as read]', error);
      return Promise.reject(error);
    }
  }
);
